import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Collapse from '@mui/material/Collapse';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AttributePane from './AttributePane';
import DailyRestrictionPane from './DailyRestrictionPane';
import PrePingPane from './PrePingPane';
import UsersPane from './UsersPane';
import AnalysisPane from './AnalysisPane';
import { TabContent } from '../TabPane';

const Criteria = ({ push, pop, _values, allDomains, source }) => {
  const [collapse, setCollapse] = useState(source === 'publisherPrePingCriteria');

  return (
    <Card
      className='criteria-card'
      sx={[
        // Card clips its content by default, which would make it the scroll root for the sticky
        // header below and stop the header sticking to whatever is actually scrolling.
        { overflow: 'visible' },
        source === 'publisherPrePingCriteria' || source === 'offer'
          ? {}
          : { width: '95%', position: 'absolute', zIndex: 10, left: 0, right: 0, margin: '40px auto auto auto' },
      ]}
    >
      <CardHeader
        onClick={() => setCollapse(!collapse)}
        // Sticky so the title — and the control that collapses the card — stays reachable while
        // a long criteria form scrolls past. Inert wherever the card does not scroll.
        sx={{
          cursor: 'pointer',
          position: 'sticky',
          top: 0,
          zIndex: 2,
          bgcolor: 'background.paper',
          // Inherited, or this opaque strip paints a square corner over the card's rounded one.
          borderTopLeftRadius: 'inherit',
          borderTopRightRadius: 'inherit',
          borderBottom: 1,
          borderColor: 'divider',
        }}
        title={
          <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
            <Typography variant='h4' component='h4'>
              Criteria
            </Typography>
            {collapse ? <ExpandLess fontSize='small' /> : <ExpandMore fontSize='small' />}
          </Stack>
        }
        slotProps={{ title: { component: 'div' } }}
      />
      <Collapse in={collapse}>
        <CardContent>
          <CriteriaBody
            push={push}
            pop={pop}
            values={_values}
            allDomains={allDomains}
            source={source}
            collapse={collapse}
          />
        </CardContent>
      </Collapse>
    </Card>
  );
};

export const CriteriaBody = ({ push, pop, allDomains = undefined, source = '', collapse }) => {
  const [activeTab, setActiveTab] = useState('Users');
  const tabNames = [
    'Users',
    'Attribute',
    'Pre-ping',
    ...(source !== 'publisherPrePingCriteria' ? ['Daily Restriction'] : []),
    'Analysis',
  ];

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={(_event, next) => setActiveTab(next)}
        variant='scrollable'
        scrollButtons='auto'
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        {tabNames.map((tab) => (
          <Tab key={tab} value={tab} label={tab} />
        ))}
      </Tabs>
      <TabContent activeTab={activeTab} sx={{ p: 2 }}>
        <UsersPane collapse={collapse} allDomains={allDomains} source={source} />
        <AttributePane collapse={collapse} push={push} source={source} />
        <PrePingPane collapse={collapse} source={source} />
        {source !== 'publisherPrePingCriteria' && <DailyRestrictionPane push={push} pop={pop} />}
        {source !== 'publisherPrePingCriteria' && <AnalysisPane source={source} />}
      </TabContent>
    </>
  );
};

export default Criteria;
